import { DataBean } from "../DataBean";

export class ReportItem extends DataBean {
  public async deleteReportItem(idReportItem: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "void_deleteReportItem_Number",
      [idReportItem]
    );
  }

  public async getReportItemCatalog(idReport: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getReportItemCatalog_Number",
      [idReport]
    );
  }

  public async getAvailableReportItems(idReport: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAvailableReportItems_Number",
      [idReport]
    );
  }

  public async addReportItem(
    idReport: number,
    index: number,
    width: number,
    columnOrder: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.reports.ReportItem_addReportItem_Number_Number_Number_Number",
      [idReport, index, width, columnOrder]
    );
  }

  public async updateReportItem(bean: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.reports.ReportItem_updateReportItem_com.quickdataerp.bean.reports.ReportItem",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.quickdataerp.bean.reports.ReportItem",
        },
      ]
    );
  }
}
